
// Contains route path constants

import UpdateWaterCharges from "../components/configuration/WaterCharges/UpdateWaterCharges";


export const routes = {
  Home: `/`,
  Login: `/login`,

  //Pages
  Sample: `/sample-page`,

  //Other
  ErrorPages: {
    Error404: `/error-pages/error-404`,
  },

  //users
  Users:  `/users`,
  UserRegister: `/user-register`,
  UpdateUser: `/update-user/:Id`,
  UpdatePassword: `/update-password/:Id`,
  UserProfilePage: `/user-profile-page/:Id`,

  
  //Distributary Zone
  DistributaryZoneUpdate: `/distributary-zone-update/:Id`,
  DistributaryZoneForm: `/distributary-zone-form`,
  DistributaryZoneList: `/distributary-zone-list`,

  //Scheme Village
  SchemeVillageAdd: `/scheme-village-Add`,
  SchemeVillageList: `/scheme-village-list`,
  SchemeVillageUpdate: `/scheme-village-update/:Id`,

  //Chack
  ChackList: `/chack-list`,
  ChackUpdate: `/chack-update/:Id`,
  ChackAdd: `/chack-add`,

  ChackInstrument: `/chack-instrument`,
  ChackInstrumentUpdate: `/chackinstrument-update/:Id`,
  AddChackInstrument: `/add-chack-instrument`,

  //Email
  EmailList: `/email-list`,
  EmailUpdate: `/email-update/:Id`,
  AddEmail: `/add-email`,

  //Chack Valve Detail
  ChackValveDetail: `/chack-valve-detail`,
  UpdateChackValveDetail: `/update-chack-valve-detail/:Id`,
  AddChackValveDetail: `/add-chack-valve-detail`,

  //Khasara
  KhasaraList: `/khasara-list`,
  KhasaraUpdate: `/khasara-update/:Id`,
  AddKhasara: `/add-khasara`,

  //Farmer
  FarmerList: `/Farmer-list`,
  FarmerUpdateL:`/farmer-update/:Id`,
  AddFarmer: `/add-farmer`,

  //Kml
  KmlList: `/kml-List`,
  AddKml:  `/add-kml`,
  UpdateKml:`/update-kml/:id`,

  MapView: `/map-view`,
  MapViewSecond:`/child-oms`,
  PopUp : `/popup`,

  //project
  ProjectList : `/project-list`,
  ProjectUpdate:`/project-update/:id`,
  ProjectAdd :`/project-add`,

  //Oms
  OmsList : `/oms-list`,
  OmsUpdate : `oms-update/:id`,
  OmsAdd :`oms-add`,
  
  //Dashboard

  DashBoard : `/dashboard`,

  //Reset-password

  ResetPassword:`/reset-password` ,

  //Emailsender
   EmailSender:`/email-sender`,

   MqttPage:`mqtt`,

   //report 

    report :`report`,

    //calendar

    Calendar : `calendar`,

    //
    Alarms: `alarms`,

    //
    BeneficiaryList:`/beneficiary-list`,
    BeneficiaryUpdate:`/beneficiary-update/:Id`,
    BeneficiaryAdd:`/beneficiary-add`,
    

    PumpingStationList:`/pumpingstation-list`,
    PumpingStaionAdd: `/pumpingstation-add`,
    PumpingStationUpdate:`/pumpingstation-update/:Id`,

    AddPumpingStationHistory : `/pumping-history-add`,
    UpdatePumpingStationHistory:`/pumping-history-update/:Id`,
    Trends:`/trends`,

    GetReportPumpingStation:`/get-report-pumping-station`,

    AddPowerConsumption:`/power-consumption-add`,
    UpdatePowerConsumption:`/power-consumption-update/:Id`,
    PowerConsuumption:`/power-consumption`,

    SchemeSummaryReport : `/scheme-summary-report`,
    SchemeWiseSummary:`/scheme-wise-summary`,
    AddSchemeSummary:`/scheme-summary-add`,

    WaterCharges:`/water-charges`,
    UpdateWaterCharges:`/update-water-charges/:Id`,
    AddWaterCharges:`/add-water-charges`,

    PumpingStationControl:`/pumping-station-control`,

    SLD:`/single-level-design`,

    WuaAllReport:`/wua-all-report`,
    WuaWiseReport:`/wua-wise-report`,

    DmsList:`/dms-list`,

    WuaList:`/wua-list`,
    AddWua:`/add-wua`,
    WuaUpdate:`/update-wua/:Id`,

    WuaWaterDistribution:`/wua-water-distribution`,

    DeviceInGroup:`/device-in-group`,
    GroupScheduler:`/group-scheduler`,

    GroupList:`/group-list`,
    GroupAdd:`/group-add`,
    GroupUpdate:`/group-update/:Id`,

    ViewAddChakInGroup:`/view-add-chak-in-group/:Id`,

    ScheduleStatus:`/schedule-status`,

    PumpingStatusReport:`/pumping-status-report`,

    WuaDashboard:`/wua-dashboard`,

    PumpKwh:`/pump-kwh`,

    PumpRunhours:`/pump-run-hours`,

    CombineReport:`/pump-runhours-kwh`,

    WuaMonth:`/wua-month`,

    PumpRun:`/pump-runhrs-onoff`



};

export default routes;